import { RouterStateSerializer } from '@ngrx/router-store';
import { Params, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

export interface RouterStateUrl {
  url: string;
  urlAfterRedirects?: string;
  params: Params;
  queryParams: Params;
}
@Injectable()
export class CustomSerializer implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    let route = routerState?.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    if (!routerState) {
      return { url: null, params: null, queryParams: null };
    }
    const {
      url,
      root: { queryParams },
    } = routerState;
    const { params } = route;

    return { url, params, queryParams };
  }
}
